module.exports = __webpack_public_path__ + "img/jin.2bb52357.png";